export default __webpack_public_path__ + "static/media/ic_arrow_right.4216d92a.svg";